import { Button } from "@website/ui-old/button";
import { useCounterButton } from "@website/ui-old/counter-button/counter-button.hook";
import styles from "@website/ui-old/counter-button/counter-button.module.scss";
import { CounterButtonPropertiesType } from "@website/ui-old/counter-button/counter-button.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const CounterButton: FC<CounterButtonPropertiesType> = (properties) => {
  const { className, variant } = properties;
  const {
    value,
    rootProps,
    decreaseButtonProps,
    increaseButtonProps,
    valueProps
  } = useCounterButton(properties);

  return (
    <div
      {...rootProps}
      className={`${styles["counter-button"]} ${
        styles[variant ?? "contained"]
      } ${className ?? ""}`}
    >
      <Button
        {...increaseButtonProps}
        datatestid="increase-button"
        size="medium"
      />
      <div
        {...valueProps}
        className={styles["value"]}
        data-testid="counter-button-value"
      >
        {value}
      </div>
      <Button
        datatestid="decrease-button"
        {...decreaseButtonProps}
        size="medium"
      />
    </div>
  );
};

const CounterButtonMemoized = memo(CounterButton, deepCompare);
/**
 * @deprecated please use @website/ui instead
 */
export { CounterButtonMemoized /**
 * @deprecated please use @website/ui instead
 */ as CounterButton };
